<template>
  <div class="succ-main">
    <div class="succ-case">
      <template v-for="item in details">
        <div class="case-banner">
          <template v-if="item.goodsId === 0">
            <img :src="item.picture"/>
          </template>
          <template v-else>
            <img src="../../assets/images/suuc.png"/>
          </template>
        </div>
        <div class="tab-con">
          <ul>
            <li><img :src="item.thumbnail"/></li>
            <li>{{item.company}}</li>
            <li style="border-bottom: 1px solid #eee;" v-if="item.impression !== 0 && item.impression !== undefined && item.impression !== null">展示量：{{item.impression}}</li>
            <li v-else></li>
            <li>
              <span v-if="item.click !== 0 && item.click !== undefined && item.click !== null">访问量：{{item.click}}</span>
              <span v-else></span>
            </li>
          </ul>
          <div>
            <div class="content-box" v-if="item.impression !== 0 && item.impression !== undefined && item.impression !== null" v-html="item.content"></div>
            <div class="content-not" v-else>暂无数据</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    created () {
      this.requestList()
    },
    data () {
      return {
        details: {}
      }
    },
    methods: {
      requestList () {
        this.details = {caseList: this.$route.query.caseList}
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .succ-main{
    width: 1010px;
    min-height:1000px;
    background: #f9f9f9;
    padding-bottom: 60px;
    box-sizing: border-box;
    .succ-case{
      width: 100%;
      height: 100%;
      margin-bottom: 50px;
      .case-banner{
        width: 100%;
        height: 260px;
        >img{
          height: 100%;
          width: 100%;
        }
      }
      .tab-con{
        width: 1100px;
        margin: 20px auto;
        padding: 0;
        >ul{
          width: 200px;
          height: 360px;
          padding: 30px;
          margin: 0px;
          box-sizing: border-box;
          list-style: none;
          float: left;
          border: 1px solid #e3e3e3;
          background: white;
          >li:nth-child(1){
            width: 140px;
            height: 140px;
            >img{
              width: 140px;
              height: 140px;
            }
          }
          >li:nth-child(2){
            width: 140px;
            height: 60px;
            line-height: 60px;
            text-align: center;
          }
          >li:nth-child(3){
            width: 140px;
            height: 60px;
            line-height: 60px;
            text-align: center;
          }
          >li:nth-child(4){
            width: 140px;
            height: 60px;
            line-height: 60px;
            text-align: center;
          }
        }
        >div{
          float: left;
          margin-left:20px;
          min-height: 600px;
          background: white;
          >.content-box{
            width: 790px;
            min-height: 600px;
            padding: 30px;
            box-sizing: border-box;
            border:1px solid #eee;
          }
          >.content-not{
            width: 790px;
            min-height: 600px;
            text-align: center;
            padding: 30px;
            box-sizing: border-box;
            border:1px solid #eee;
            color: #999;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/SucceedDetails.vue